<div class="section-wrapper">
  <div class="section-wrapper-inner" #selectionInner>
    @for (item of options; track item) {
      <button
        class="btn btn-plain section-item"
        [class.active]="currentSection.name === item"
        (click)="setActiveSection(item)"
        [attr.data-section]="item"
      >
        {{ item }}
      </button>
    }
  </div>
</div>

@if (options && options.length > 1) {
  <div class="mb-transcript-section-scroller">
    <button
      class="btn btn-plain"
      [disabled]="currentSection && currentSection.isFirst"
      (click)="scrollSectionBackward()"
    >
      <span class="mb-icon mb-icon-back-thin"></span>
    </button>
    <button class="btn btn-plain" [disabled]="currentSection && currentSection.isLast" (click)="scrollSectionForward()">
      <span class="mb-icon mb-icon-forward-thin"></span>
    </button>
  </div>
}
